import { render, staticRenderFns } from "./SoundTagDialog.vue?vue&type=template&id=8e83a548&scoped=true"
import script from "./SoundTagDialog.vue?vue&type=script&lang=js"
export * from "./SoundTagDialog.vue?vue&type=script&lang=js"
import style0 from "./SoundTagDialog.vue?vue&type=style&index=0&id=8e83a548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e83a548",
  null
  
)

export default component.exports